var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAcceptedCheck = function SvgAcceptedCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.043c-3.921 0-7.111 3.19-7.111 7.111s3.19 7.111 7.11 7.111c3.922 0 7.112-3.19 7.112-7.11 0-3.922-3.19-7.112-7.111-7.112m0 12.444a5.34 5.34 0 0 1-5.334-5.333A5.34 5.34 0 0 1 8 2.821a5.34 5.34 0 0 1 5.333 5.333A5.34 5.34 0 0 1 8 13.487"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.11 10.82a.89.89 0 0 1-.628-.26L4.705 8.783a.888.888 0 1 1 1.257-1.257L7.11 8.675l2.927-2.927a.888.888 0 1 1 1.257 1.257L7.739 10.56a.89.89 0 0 1-.628.26"
  })));
};
export default SvgAcceptedCheck;